import React, { useState, useEffect, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import RestaurantDetailPage from "./RestaurantDetail";
import { getData, serverURL } from "../../../../Services/Fetchnodeservices";

// ─────────────────────────────────────────────────────────────────────────────
// MAP RESTAURANT DATA FUNCTION
// ─────────────────────────────────────────────────────────────────────────────

const mapRestaurantData = (item) => ({
  id: item.id,
  restroId: item.id,
  old_id: item.old_id || item.id,
  name: item.name || "",
  organisation_name: item.organisation_name || item.name || "",
  org_type: item.org_type || "",
  pre: item.pre || "",
  gender: item.gender || "",
  contact: item.contact || item.owner_mobile || "",
  email: item.email || "",
  password: item.password || "",
  location: item.location || "",
  city: item.city || item.address?.split(',').pop()?.trim() || "Unknown",
  state: item.state || "",
  postal: item.postal || "",
  address: item.address || "",
  area: item.area || item.locality || "",
  latitude: item.latitude || null,
  longitude: item.longitude || null,
  owner_name: item.owner_name || "",
  owner_mobile: item.owner_mobile || "",
  other_person_name: item.other_person_name || "",
  other_person_mobile: item.other_person_mobile || "",
  meet_to: item.meet_to || "",
  interestedin_zaptodoor: item.interestedin || "",
  bank_name: item.bank_name || "",
  bank_branch: item.bank_branch || "",
  bank_type: item.bank_type || "",
  account_holder: item.account_holder || "",
  account_number: item.account_number || "",
  ifsc: item.ifsc || "",
  ifsc_code: item.ifsc || "",
  bank_mobile: item.bank_mobile || "",
  upi: item.upi || "",
  comission: item.comission || "",
  special_comission: item.special_comission || "",
  min_order: item.min_order || "",
  platform_charge: item.platform_charge || "0",
  handling_charge: item.handling_charge || "",
  gst_percentage: item.gst_percentage || "",
  order_receiving_charges: item.order_receiving_charges || "",
  subscription_id: item.subscription_id || "",
  paid: item.paid === "1",
  wallet: item.wallet || "0",
  myreferal: item.myreferal || "",
  refer_by: item.refer_by || "",
  refer_code: item.refer_by || item.myreferal || "",
  is_mou: item.is_mou || "",
  status: item.status === "1" ? "Active" : "Inactive",
  hide: item.hide || "",
  open_status: item.open_status || "",
  ready: item.open_status === "1" ? "Yes" : "No",
  onOff: item.open_status === "1" ? "ON" : "OFF",
  shift_start: item.shift_start || "",
  shiftEnd: item.shift_end || "",
  shiftStart: item.shift_start || "10:00 AM",
  shift_end: item.shift_end || "10:00 PM",
  is_auto_schedule: item.is_auto_schedule || "",
  is_schedule_approved: item.is_schedule_approved || "",
  is_verify_personalinfo: item.is_verify_personalinfo || "",
  is_verify_docinfo: item.is_verify_docinfo || "",
  is_verify_bankinfo: item.is_verify_bankinfo || "",
  remarks_personalinfo: item.remarks_personalinfo || "",
  remarks_docinfo: item.remarks_docinfo || "",
  remarks_bankinfo: item.remarks_bankinfo || "",
  is_menu: item.is_menu || "",
  isKOT: item.isKOT || "",
  isBill: item.isBill || "",
  menu_direction: item.menu_direction || "neutral",
  menu_direction_type: item.menu_direction_type || "percentage",
  menu_direction_value: item.menu_direction_value || "",
  details: item.details || "",
  description: item.details || "",
  subject: item.subject || "",
  interestedin: item.interestedin || "",
  created_by_id: item.created_by_id || "",
  gst_number: item.gst_number || "",
  food_license_number: item.food_license_number || "",
  pic: item.pic || item.r_logo || null,
  r_logo: item.r_logo || null,
  h_logo: item.h_logo || null,
  restropic: item.pic || item.r_logo || null,
  aadhar_front: item.aadhar_front || null,
  aadhar_back: item.aadhar_back || null,
  pan_card: item.pan_card || null,
  gst_pic: item.gst_pic || null,
  food_license_pic: item.food_license_pic || null,
  bank_pass: item.bank_pass || null,
  cancel_cheque: item.cancel_cheque || null,
  current_menu_page1: item.current_menu_page1 || null,
  current_menu_page2: item.current_menu_page2 || null,
  current_menu_page3: item.current_menu_page3 || null,
  current_menu_page4: item.current_menu_page4 || null,
  current_menu_page5: item.current_menu_page5 || null,
  current_menu_page6: item.current_menu_page6 || null,
  current_menu_page7: item.current_menu_page7 || null,
  current_menu_page8: item.current_menu_page8 || null,
  current_menu_page9: item.current_menu_page9 || null,
  rating: parseFloat(item.rating) || 4.0,
  totalRatings: parseInt(item.total_ratings) || 0,
  totalReviews: parseInt(item.total_reviews) || 0,
  totalPayments: parseFloat(item.platform_charge) || 0,
  pendingPayments: 0,
  completedPayments: 0,
  cuisine: item.cuisine || "",
  platform_share: parseFloat(item.comission) || 0,
  pay_perclick: 0,
  login_session: item.sessionid || item.login_session || "",
  phn_otp1: item.contact || "",
  phn_otp2: "",
  created_at: item.created_at,
  updated_at: item.updated_at,
  _raw: {
    status: item.status,
    open_status: item.open_status,
    shift_start: item.shift_start,
    shift_end: item.shift_end,
    sessionid: item.sessionid,
    refer_by: item.refer_by,
    r_logo: item.r_logo
  },
  schedule: [
    { day: "Monday", openTime: item.shift_start || "09:00", closeTime: item.shift_end || "23:00", isClosed: false },
    { day: "Tuesday", openTime: item.shift_start || "09:00", closeTime: item.shift_end || "23:00", isClosed: false },
    { day: "Wednesday", openTime: item.shift_start || "09:00", closeTime: item.shift_end || "23:00", isClosed: false },
    { day: "Thursday", openTime: item.shift_start || "09:00", closeTime: item.shift_end || "23:00", isClosed: false },
    { day: "Friday", openTime: item.shift_start || "09:00", closeTime: item.shift_end || "23:00", isClosed: false },
    { day: "Saturday", openTime: item.shift_start || "10:00", closeTime: item.shift_end || "00:00", isClosed: false },
    { day: "Sunday", openTime: item.shift_start || "10:00", closeTime: item.shift_end || "22:00", isClosed: false }
  ],
  menu: []
});

// ─────────────────────────────────────────────────────────────────────────────
// ICONS
// ─────────────────────────────────────────────────────────────────────────────
const TrashIcon = () => (<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>);
const SearchIcon = () => (<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>);
const ChevronLeftIcon = () => (<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="15 18 9 12 15 6"/></svg>);
const ChevronRightIcon = () => (<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="9 18 15 12 9 6"/></svg>);
const PlusIcon = () => (<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>);
const StarIcon = () => (<svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor" stroke="none"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>);
const LocationPinIcon = () => (<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="12" r="3"/></svg>);
const CheckCircleIcon = () => (<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>);
const XCircleIcon = () => (<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>);
const PowerIcon = () => (<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M18.36 6.64a9 9 0 1 1-12.73 0"/><line x1="12" y1="2" x2="12" y2="12"/></svg>);
const MenuIcon = () => (<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>);
const ShieldCheckIcon = () => (<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><polyline points="9 12 11 14 15 10"/></svg>);
const ShieldOffIcon = () => (<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><line x1="12" y1="8" x2="12" y2="14"/><line x1="9" y1="11" x2="15" y2="11"/></svg>);

// ─────────────────────────────────────────────────────────────────────────────
// SUB-COMPONENTS
// ─────────────────────────────────────────────────────────────────────────────

const RestaurantAvatar = ({ pic, name, isDark }) => {
  const [imageError, setImageError] = useState(false);
  const getCleanFilename = (picPath) => {
    if (!picPath || picPath.trim() === "") return null;
    if (picPath.includes('/')) return picPath.split('/').pop();
    return picPath;
  };
  const filename = getCleanFilename(pic);
  const imageUrl = filename ? `${serverURL}/public/uploadnew/upload/${filename}` : null;
  if (!imageUrl || imageError) {
    const initial = name?.charAt(0) || "🍔";
    return <div style={{ width: "28px", height: "28px", borderRadius: "50%", background: "linear-gradient(135deg, #3b82f6, #8b5cf6)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "12px", fontWeight: 600, color: "#fff" }}>{initial}</div>;
  }
  return <img src={imageUrl} alt={name} onError={() => setImageError(true)} style={{ width: "28px", height: "28px", borderRadius: "50%", objectFit: "cover", border: `1px solid ${isDark ? "#2a3145" : "#e5e7eb"}` }} />;
};

const StatusBadge = ({ status }) => {
  const config = { Active: { bg: "rgba(20,184,166,0.15)", color: "#14b8a6", dot: "#14b8a6" }, Inactive: { bg: "rgba(148,163,184,0.12)", color: "#94a3b8", dot: "#94a3b8" } };
  const c = config[status] || config.Inactive;
  return <div style={{ display: "inline-flex", alignItems: "center", gap: "4px", padding: "2px 8px 2px 6px", borderRadius: "16px", background: c.bg, border: `1px solid ${c.bg}` }}><div style={{ width: "4px", height: "4px", borderRadius: "50%", background: c.dot }} /><span style={{ fontSize: "10px", fontWeight: 600, color: c.color }}>{status}</span></div>;
};

const ReadyBadge = ({ ready }) => {
  const config = { Yes: { bg: "rgba(20,184,166,0.15)", color: "#14b8a6" }, No: { bg: "rgba(245,158,11,0.12)", color: "#f59e0b" } };
  const c = config[ready] || config.No;
  return <span style={{ padding: "2px 8px", borderRadius: "10px", fontSize: "10px", fontWeight: 600, background: c.bg, color: c.color }}>{ready}</span>;
};

const OnOffBadge = ({ value }) => {
  const config = { ON: { bg: "rgba(34,197,94,0.15)", color: "#22c55e" }, OFF: { bg: "rgba(148,163,184,0.12)", color: "#94a3b8" } };
  const c = config[value] || config.OFF;
  return <span style={{ padding: "2px 8px", borderRadius: "10px", fontSize: "10px", fontWeight: 700, background: c.bg, color: c.color }}>{value}</span>;
};

const Checkbox = ({ checked, onChange }) => (
  <div onClick={onChange} style={{ width: "14px", height: "14px", borderRadius: "3px", border: checked ? "2px solid #3b82f6" : "2px solid #3a4460", background: checked ? "#3b82f6" : "transparent", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", transition: "all 0.15s ease" }}>
    {checked && <svg width="8" height="8" viewBox="0 0 12 12" fill="none"><path d="M2 6l3 3 5-5" stroke="#fff" strokeWidth="2" strokeLinecap="round"/></svg>}
  </div>
);

const Toast = ({ message, type, onClose }) => (
  <div style={{ position: "fixed", bottom: "24px", right: "24px", zIndex: 999, background: type === "error" ? "#1a0a0a" : "#0a1a0a", border: `1px solid ${type === "error" ? "rgba(239,68,68,0.4)" : "rgba(16,185,129,0.4)"}`, borderRadius: "10px", padding: "10px 16px", display: "flex", alignItems: "center", gap: "8px", boxShadow: "0 8px 32px rgba(0,0,0,0.5)", animation: "slideUp 0.25s ease" }}>
    <div style={{ width: "6px", height: "6px", borderRadius: "50%", background: type === "error" ? "#ef4444" : "#10b981" }} />
    <span style={{ fontSize: "12px", color: type === "error" ? "#fca5a5" : "#6ee7b7", flex: 1 }}>{message}</span>
    <span onClick={onClose} style={{ cursor: "pointer", color: "#64748b", fontSize: "14px" }}>×</span>
  </div>
);

const DeleteConfirmModal = ({ isOpen, restaurantName, onConfirm, onCancel, isDark }) => {
  if (!isOpen) return null;
  return (
    <div style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, background: "rgba(0,0,0,0.7)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000, animation: "fadeIn 0.2s ease" }}>
      <div style={{ background: isDark ? "#141824" : "#ffffff", borderRadius: "12px", padding: "20px", maxWidth: "350px", width: "90%", border: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0" }}>
        <h3 style={{ color: isDark ? "#f1f5f9" : "#1e293b", marginBottom: "8px", fontSize: "16px" }}>Confirm Delete</h3>
        <p style={{ color: isDark ? "#94a3b8" : "#64748b", marginBottom: "16px", fontSize: "13px" }}>Are you sure you want to delete <strong>{restaurantName}</strong>?</p>
        <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}>
          <button onClick={onCancel} style={{ padding: "6px 14px", borderRadius: "6px", border: "1px solid #1e2740", background: "transparent", color: isDark ? "#94a3b8" : "#64748b", cursor: "pointer", fontSize: "12px" }}>Cancel</button>
          <button onClick={onConfirm} style={{ padding: "6px 14px", borderRadius: "6px", border: "none", background: "#ef4444", color: "white", cursor: "pointer", fontSize: "12px" }}>Delete</button>
        </div>
      </div>
    </div>
  );
};

const RestaurantMenuModal = ({ restaurant, onClose, isDark }) => (
  <div style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, background: "rgba(0,0,0,0.7)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000 }}>
    <div style={{ background: isDark ? "#141824" : "#ffffff", borderRadius: "12px", padding: "20px", width: "90%", maxWidth: "600px", maxHeight: "80vh", overflow: "auto" }}>
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "16px" }}>
        <h3 style={{ color: isDark ? "#f1f5f9" : "#1e293b", fontSize: "16px" }}>Menu - {restaurant.name}</h3>
        <button onClick={onClose} style={{ background: "none", border: "none", color: "#64748b", fontSize: "18px", cursor: "pointer" }}>×</button>
      </div>
      <p style={{ textAlign: "center", color: "#64748b", padding: "30px", fontSize: "13px" }}>Menu management coming soon</p>
    </div>
  </div>
);

const ScheduleModal = ({ isOpen, restaurant, scheduleItems, onUpdate, onDelete, onAdd, onClose, onSave, isDark }) => {
  const [newItem, setNewItem] = useState({ day: "Monday", openTime: "09:00", closeTime: "17:00", isClosed: false });
  if (!isOpen) return null;
  const days = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
  return (
    <div style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, background: "rgba(0,0,0,0.7)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000 }}>
      <div style={{ background: isDark ? "#141824" : "#ffffff", borderRadius: "12px", padding: "20px", width: "90%", maxWidth: "800px", maxHeight: "80vh", overflow: "auto" }}>
        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "16px" }}>
          <h3 style={{ color: isDark ? "#f1f5f9" : "#1e293b", fontSize: "16px" }}>Schedule - {restaurant?.name}</h3>
          <button onClick={onClose} style={{ background: "none", border: "none", color: "#64748b", fontSize: "18px", cursor: "pointer" }}>×</button>
        </div>
        <div style={{ marginBottom: "16px" }}>
          <h4 style={{ color: isDark ? "#f1f5f9" : "#1e293b", fontSize: "13px", marginBottom: "10px" }}>Add New Schedule</h4>
          <div style={{ display: "flex", gap: "8px", flexWrap: "wrap", alignItems: "center" }}>
            <select value={newItem.day} onChange={(e) => setNewItem({ ...newItem, day: e.target.value })} style={{ padding: "5px 8px", background: isDark ? "#0d1117" : "#f8fafc", border: "1px solid #1e2740", borderRadius: "4px", color: isDark ? "#f1f5f9" : "#1e293b", fontSize: "12px" }}>
              {days.map(day => <option key={day}>{day}</option>)}
            </select>
            <input type="time" value={newItem.openTime} onChange={(e) => setNewItem({ ...newItem, openTime: e.target.value })} style={{ padding: "5px 8px", background: isDark ? "#0d1117" : "#f8fafc", border: "1px solid #1e2740", borderRadius: "4px", color: isDark ? "#f1f5f9" : "#1e293b", fontSize: "12px" }} />
            <input type="time" value={newItem.closeTime} onChange={(e) => setNewItem({ ...newItem, closeTime: e.target.value })} style={{ padding: "5px 8px", background: isDark ? "#0d1117" : "#f8fafc", border: "1px solid #1e2740", borderRadius: "4px", color: isDark ? "#f1f5f9" : "#1e293b", fontSize: "12px" }} />
            <label style={{ display: "flex", alignItems: "center", gap: "4px", fontSize: "11px", color: isDark ? "#64748b" : "#475569" }}>
              <input type="checkbox" checked={newItem.isClosed} onChange={(e) => setNewItem({ ...newItem, isClosed: e.target.checked })} /> Closed
            </label>
            <button onClick={() => { if (scheduleItems.some(item => item.day === newItem.day)) { alert("Schedule for this day already exists"); return; } onAdd(newItem); setNewItem({ day: "Monday", openTime: "09:00", closeTime: "17:00", isClosed: false }); }} style={{ padding: "5px 12px", background: "#4a6cf7", border: "none", borderRadius: "4px", color: "white", cursor: "pointer", fontSize: "11px" }}>Add</button>
          </div>
        </div>
        <div>
          <h4 style={{ color: isDark ? "#f1f5f9" : "#1e293b", fontSize: "13px", marginBottom: "10px" }}>Current Schedule</h4>
          <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
            {scheduleItems.map((item, idx) => (
              <div key={idx} style={{ display: "flex", alignItems: "center", gap: "10px", padding: "6px", border: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0", borderRadius: "6px", flexWrap: "wrap" }}>
                <span style={{ width: "90px", fontWeight: 600, color: isDark ? "#f1f5f9" : "#1e293b", fontSize: "12px" }}>{item.day}</span>
                <input type="time" value={item.openTime} onChange={(e) => onUpdate(idx, { ...item, openTime: e.target.value })} style={{ padding: "4px 6px", background: isDark ? "#0d1117" : "#f8fafc", border: "1px solid #1e2740", borderRadius: "4px", fontSize: "11px" }} />
                <span style={{ fontSize: "11px" }}>-</span>
                <input type="time" value={item.closeTime} onChange={(e) => onUpdate(idx, { ...item, closeTime: e.target.value })} style={{ padding: "4px 6px", background: isDark ? "#0d1117" : "#f8fafc", border: "1px solid #1e2740", borderRadius: "4px", fontSize: "11px" }} />
                <label style={{ fontSize: "11px", display: "flex", alignItems: "center", gap: "3px" }}><input type="checkbox" checked={item.isClosed} onChange={(e) => onUpdate(idx, { ...item, isClosed: e.target.checked })} /> Closed</label>
                <button onClick={() => onDelete(idx)} style={{ marginLeft: "auto", background: "none", border: "none", color: "#ef4444", cursor: "pointer", fontSize: "11px" }}>Delete</button>
              </div>
            ))}
          </div>
        </div>
        <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end", marginTop: "16px" }}>
          <button onClick={onClose} style={{ padding: "6px 14px", background: "transparent", border: "1px solid #1e2740", borderRadius: "6px", color: isDark ? "#94a3b8" : "#64748b", cursor: "pointer", fontSize: "12px" }}>Cancel</button>
          <button onClick={onSave} style={{ padding: "6px 14px", background: "#4a6cf7", border: "none", borderRadius: "6px", color: "white", cursor: "pointer", fontSize: "12px" }}>Save Schedule</button>
        </div>
      </div>
    </div>
  );
};

// ─────────────────────────────────────────────────────────────────────────────
// MAIN COMPONENT - RestaurantTable
// ─────────────────────────────────────────────────────────────────────────────
const RestaurantTable = ({ isDark = true }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [restaurants, setRestaurants] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("All");
  const [readyFilter, setReadyFilter] = useState("All");
  const [onOffFilter, setOnOffFilter] = useState("All");
  const [locationFilter, setLocationFilter] = useState("All");
  const [uniqueLocations, setUniqueLocations] = useState([]);
  const [selected, setSelected] = useState(new Set());
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [toast, setToast] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(null);
  const [showDetailPage, setShowDetailPage] = useState(null);
  const [showMenuModal, setShowMenuModal] = useState(null);
  const [showScheduleModal, setShowScheduleModal] = useState(false);
  const [scheduleItems, setScheduleItems] = useState([]);
  const [scheduleRestaurant, setScheduleRestaurant] = useState(null);
  const [locationStats, setLocationStats] = useState({});
  const [actionLoading, setActionLoading] = useState(false);
  const [isPreFiltered, setIsPreFiltered] = useState(false);
  const [preFilteredData, setPreFilteredData] = useState(null);

  const showToast = (message, type = "success") => { 
    setToast({ message, type }); 
    setTimeout(() => setToast(null), 3500); 
  };
  
  const handleAddRestaurantClick = () => {
    navigate("/Dashboard/addrestaurant", { state: { mode: "add" } });
  };
  
  const handleEditRestaurantClick = (restaurant) => {
    navigate("/Dashboard/addrestaurant", { state: { mode: "edit", restaurantData: restaurant } });
  };
  
  const handleViewRestaurant = (restro) => {
    console.log("Viewing restaurant with full data:", restro);
    setShowDetailPage(restro);
  };
  
  useEffect(() => { 
    const t = setTimeout(() => { 
      setDebouncedSearch(search); 
      setPage(1); 
    }, 500); 
    return () => clearTimeout(t); 
  }, [search]);
  
  // Check for pre-filtered data from navigation
  useEffect(() => {
    const state = location.state;
    console.log("📍 RestaurantTable - Location state:", state);
    if (state && state.activeRestaurantData) {
      console.log("✅ Received pre-filtered restaurant data from Dashboard:", state);
      console.log("✅ Number of restaurants:", state.activeRestaurantData.length);
      setPreFilteredData(state.activeRestaurantData);
      setIsPreFiltered(true);
    } else {
      console.log("❌ No pre-filtered data found, will fetch from API");
      setIsPreFiltered(false);
      setPreFilteredData(null);
    }
  }, [location.state]);
  
  const extractUniqueLocations = (restaurantsData) => {
    const locations = new Set();
    locations.add("All");
    restaurantsData.forEach(restaurant => {
      const city = restaurant.city || restaurant.address?.split(',').pop()?.trim();
      const area = restaurant.area || restaurant.locality;
      if (city && city !== "Unknown") locations.add(city);
      if (area && area !== "Unknown") locations.add(area);
    });
    return Array.from(locations);
  };
  
  const calculateLocationStats = (restaurantsData) => {
    const stats = {};
    restaurantsData.forEach(restaurant => {
      const city = restaurant.city || restaurant.address?.split(',').pop()?.trim() || "Unknown";
      const area = restaurant.area || restaurant.locality || "";
      const locationKey = area || city;
      if (locationKey && locationKey !== "Unknown") {
        stats[locationKey] = (stats[locationKey] || 0) + 1;
      }
    });
    return stats;
  };
  
  const fetchRestaurants = useCallback(async () => { 
    setLoading(true); 
    try {
      // Check if we have data from navigation FIRST
      const state = location.state;
      if (state && state.activeRestaurantData && state.activeRestaurantData.length > 0) {
        console.log("🔍 Using navigation data directly:", state.activeRestaurantData.length, "restaurants");
        // Sort pre-filtered data in decreasing order
        const sortedData = [...state.activeRestaurantData].sort((a, b) => {
          if (a.created_at && b.created_at) {
            return new Date(b.created_at) - new Date(a.created_at);
          }
          return parseInt(b.id) - parseInt(a.id);
        });
        const mappedData = sortedData.map(item => mapRestaurantData(item));
        
        // Apply filters on the pre-filtered data
        let filtered = [...mappedData];
        
        // ✅ IMPROVED SEARCH - Search across ALL fields
        if (debouncedSearch) {
          const searchLower = debouncedSearch.toLowerCase().trim();
          filtered = filtered.filter(r => {
            // Search in all relevant fields
            const searchableFields = [
              r.name,
              r.organisation_name,
              r.owner_mobile,
              r.contact,
              r.email,
              r.address,
              r.city,
              r.area,
              r.state,
              r.postal,
              r.bank_name,
              r.account_number,
              r.ifsc,
              r.gst_number,
              r.food_license_number,
              r.details,
              r.description,
              r.cuisine,
              r.owner_name,
              r.other_person_name,
              r.other_person_mobile,
              r.meet_to,
              r.myreferal,
              r.refer_code,
              r.refer_by,
              r.subject,
              r.interestedin,
              r.location,
              r.id?.toString()
            ];
            
            return searchableFields.some(field => 
              field && field.toString().toLowerCase().includes(searchLower)
            );
          });
        }
        if (statusFilter && statusFilter !== "All") {
          filtered = filtered.filter(r => r.status === statusFilter);
        }
        if (readyFilter && readyFilter !== "All") {
          filtered = filtered.filter(r => r.ready === readyFilter);
        }
        if (onOffFilter && onOffFilter !== "All") {
          filtered = filtered.filter(r => r.onOff === onOffFilter);
        }
        if (locationFilter && locationFilter !== "All") {
          filtered = filtered.filter(r => r.city === locationFilter || r.area === locationFilter);
        }
        
        // Pagination
        const start = (page - 1) * perPage;
        const paginated = filtered.slice(start, start + perPage);
        
        setRestaurants(paginated);
        setTotal(filtered.length);
        setIsPreFiltered(true);
        
        // Set locations from pre-filtered data
        const uniqueLocs = extractUniqueLocations(sortedData);
        setUniqueLocations(uniqueLocs);
        const stats = calculateLocationStats(sortedData);
        setLocationStats(stats);
        
        setLoading(false);
        return;
      }
      
      // Otherwise fetch from API
      console.log("🔍 Fetching from API");
      const response = await getData("restaurant/Restrunts");
      const data = response;
      let restaurantsList = Array.isArray(data) ? data : (data.data || data.items || []);
      
      // ✅ SORT IN DECREASING ORDER (NEWEST FIRST)
      restaurantsList = restaurantsList.sort((a, b) => {
        if (a.created_at && b.created_at) {
          return new Date(b.created_at) - new Date(a.created_at);
        }
        return parseInt(b.id) - parseInt(a.id);
      });
      
      let filtered = [...restaurantsList];
      
      // ✅ IMPROVED SEARCH - Search across ALL fields
      if (debouncedSearch) {
        const searchLower = debouncedSearch.toLowerCase().trim();
        filtered = filtered.filter(r => {
          // Search in all relevant fields from the raw data
          const searchableFields = [
            r.name,
            r.organisation_name,
            r.owner_mobile,
            r.contact,
            r.email,
            r.address,
            r.city,
            r.area,
            r.state,
            r.postal,
            r.bank_name,
            r.account_number,
            r.ifsc,
            r.gst_number,
            r.food_license_number,
            r.details,
            r.description,
            r.cuisine,
            r.owner_name,
            r.other_person_name,
            r.other_person_mobile,
            r.meet_to,
            r.myreferal,
            r.refer_by,
            r.subject,
            r.interestedin,
            r.location,
            r.id?.toString()
          ];
          
          return searchableFields.some(field => 
            field && field.toString().toLowerCase().includes(searchLower)
          );
        });
      }
      if (statusFilter && statusFilter !== "All") {
        filtered = filtered.filter(r => {
          const itemStatus = r.status === "1" ? "Active" : "Inactive";
          return itemStatus === statusFilter;
        });
      }
      if (readyFilter && readyFilter !== "All") {
        filtered = filtered.filter(r => {
          const itemReady = r.open_status === "1" ? "Yes" : "No";
          return itemReady === readyFilter;
        });
      }
      if (onOffFilter && onOffFilter !== "All") {
        filtered = filtered.filter(r => {
          const itemOnOff = r.open_status === "1" ? "ON" : "OFF";
          return itemOnOff === onOffFilter;
        });
      }
      if (locationFilter && locationFilter !== "All") {
        filtered = filtered.filter(r => {
          const restaurantCity = r.city || r.address?.split(',').pop()?.trim() || "Unknown";
          const restaurantArea = r.area || r.locality || "";
          return restaurantCity === locationFilter || restaurantArea === locationFilter;
        });
      }
      
      const start = (page - 1) * perPage;
      const paginated = filtered.slice(start, start + perPage);
      
      // ✅ CALCULATE SN IN DECREASING ORDER
      const totalFiltered = filtered.length;
      const mappedData = paginated.map((item, index) => {
        const decreasingSn = totalFiltered - start - index;
        return {
          ...mapRestaurantData(item),
          sn: decreasingSn
        };
      });
      
      setRestaurants(mappedData);
      setTotal(filtered.length);
      setIsPreFiltered(false);
      
      // Get all data for locations
      const allRes = await getData("restaurant/Restrunts");
      let allData = Array.isArray(allRes) ? allRes : (allRes.data || allRes.items || []);
      allData = allData.sort((a, b) => {
        if (a.created_at && b.created_at) {
          return new Date(b.created_at) - new Date(a.created_at);
        }
        return parseInt(b.id) - parseInt(a.id);
      });
      const uniqueLocs = extractUniqueLocations(allData);
      setUniqueLocations(uniqueLocs);
      const stats = calculateLocationStats(allData);
      setLocationStats(stats);
      
    } catch (err) { 
      console.error("Error fetching restaurants:", err);
      showToast(`Failed to load: ${err.message}`, "error"); 
    } finally { 
      setLoading(false); 
    } 
  }, [page, perPage, debouncedSearch, statusFilter, readyFilter, onOffFilter, locationFilter, location.state]);
  
  useEffect(() => { 
    fetchRestaurants(); 
  }, [fetchRestaurants]);

  // ─────────────────────────────────────────────────────────────────────────────
  // BULK ACTIONS
  // ─────────────────────────────────────────────────────────────────────────────

  const handleBulkAction = async (action) => {
    if (selected.size === 0) {
      showToast("Please select at least one restaurant", "error");
      return;
    }

    setActionLoading(true);
    try {
      const ids = Array.from(selected);
      console.log(`Performing ${action} on:`, ids);
      
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      showToast(`${selected.size} restaurant(s) ${action} successfully`);
      
      const updatedRestaurants = restaurants.map(r => {
        if (ids.includes(r.id)) {
          switch(action) {
            case 'activated': return { ...r, status: 'Active' };
            case 'deactivated': return { ...r, status: 'Inactive' };
            case 'set ready': return { ...r, ready: 'Yes', onOff: 'ON' };
            case 'unset ready': return { ...r, ready: 'No', onOff: 'OFF' };
            case 'turned ON': return { ...r, onOff: 'ON' };
            case 'turned OFF': return { ...r, onOff: 'OFF' };
            default: return r;
          }
        }
        return r;
      });
      setRestaurants(updatedRestaurants);
      
      clearSelection();
    } catch (err) {
      showToast(`Failed to ${action}: ${err.message}`, "error");
    } finally {
      setActionLoading(false);
    }
  };

  const handleDeleteSelected = async () => { 
    if (selected.size === 0) {
      showToast("Please select at least one restaurant", "error");
      return;
    }
    try { 
      showToast(`${selected.size} restaurant(s) deleted`); 
      clearSelection(); 
      setShowDeleteModal(null); 
      fetchRestaurants();
    } catch (err) { 
      showToast(`Delete failed: ${err.message}`, "error"); 
    } 
  };
  
  const handleDeleteFromDetail = async (restaurant) => { 
    setShowDeleteModal(restaurant); 
  };
  
  const openScheduleModal = (restaurant) => {
    setScheduleRestaurant(restaurant);
    setScheduleItems(restaurant.schedule && restaurant.schedule.length > 0 ? restaurant.schedule : [
      { day: "Monday", openTime: restaurant.shiftStart || "09:00", closeTime: restaurant.shiftEnd || "17:00", isClosed: false },
      { day: "Tuesday", openTime: restaurant.shiftStart || "09:00", closeTime: restaurant.shiftEnd || "17:00", isClosed: false },
      { day: "Wednesday", openTime: restaurant.shiftStart || "09:00", closeTime: restaurant.shiftEnd || "17:00", isClosed: false },
      { day: "Thursday", openTime: restaurant.shiftStart || "09:00", closeTime: restaurant.shiftEnd || "17:00", isClosed: false },
      { day: "Friday", openTime: restaurant.shiftStart || "09:00", closeTime: restaurant.shiftEnd || "17:00", isClosed: false },
      { day: "Saturday", openTime: restaurant.shiftStart || "09:00", closeTime: restaurant.shiftEnd || "17:00", isClosed: false },
      { day: "Sunday", openTime: restaurant.shiftStart || "09:00", closeTime: restaurant.shiftEnd || "17:00", isClosed: false }
    ]);
    setShowScheduleModal(true);
  };
  
  const addScheduleItem = (newItem) => {
    if (scheduleItems.some(item => item.day === newItem.day)) {
      showToast("Schedule for this day already exists", "error");
      return;
    }
    setScheduleItems([...scheduleItems, { ...newItem }]);
  };
  
  const updateScheduleItem = (index, updatedItem) => { 
    const updated = [...scheduleItems]; 
    updated[index] = updatedItem; 
    setScheduleItems(updated); 
  };
  
  const deleteScheduleItem = (index) => setScheduleItems(scheduleItems.filter((_, i) => i !== index));
  
  const saveSchedule = async () => {
    try {
      showToast("Opening/Closing times updated successfully");
      setShowScheduleModal(false);
      fetchRestaurants();
      if (showDetailPage && showDetailPage.id === scheduleRestaurant.id) {
        setShowDetailPage({ ...showDetailPage, schedule: scheduleItems });
      }
    } catch (err) {
      showToast(`Failed to save schedule: ${err.message}`, "error");
    }
  };
  
  const totalPages = Math.ceil(total / perPage);
  
  // ✅ SN already calculated in fetchRestaurants, no need to recalculate
  const mappedRestaurants = restaurants;
  
  const allPageSelected = mappedRestaurants.length > 0 && mappedRestaurants.every(r => selected.has(r.id));
  const toggleAll = () => {
    if (allPageSelected) {
      const newSelected = new Set(selected);
      mappedRestaurants.forEach(r => newSelected.delete(r.id));
      setSelected(newSelected);
    } else {
      const newSelected = new Set(selected);
      mappedRestaurants.forEach(r => newSelected.add(r.id));
      setSelected(newSelected);
    }
  };
  
  const toggleOne = (id) => {
    const newSelected = new Set(selected);
    if (newSelected.has(id)) {
      newSelected.delete(id);
    } else {
      newSelected.add(id);
    }
    setSelected(newSelected);
  };
  
  const clearSelection = () => setSelected(new Set());
  
  // Function to go to last page
  const goToLastPage = () => {
    if (totalPages > 0) {
      setPage(totalPages);
    }
  };

  // Function to go to first page
  const goToFirstPage = () => {
    setPage(1);
  };
  
  // Column widths
  const columnWidths = {
    checkbox: "32px",
    sn: "40px",
    id: "55px",
    status: "70px",
    ready: "55px",
    onoff: "55px",
    open: "60px",
    close: "60px",
    restaurant: "140px",
    rating: "65px",
    contact: "95px",
    actions: "75px"
  };
  
  const styles = {
    container: { minHeight: "100vh", background: isDark ? "#0d1117" : "#f8fafc", fontFamily: "'DM Sans', sans-serif", padding: "16px 20px" },
    headerActions: { display: "flex", gap: "10px", marginBottom: "16px", flexWrap: "wrap" },
    addBtn: { background: "#4a6cf7", color: "white", border: "none", padding: "8px 16px", borderRadius: "8px", cursor: "pointer", fontWeight: 600, fontSize: "12px", display: "flex", alignItems: "center", gap: "5px" },
    filtersBar: { display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px", flexWrap: "wrap", gap: "12px" },
    searchWrapper: { position: "relative", flex: 1, maxWidth: "300px" },
    searchInput: { width: "100%", padding: "8px 10px 8px 32px", background: isDark ? "#141824" : "#ffffff", border: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0", borderRadius: "8px", fontSize: "12px", color: isDark ? "#f1f5f9" : "#1e293b", outline: "none" },
    searchIcon: { position: "absolute", left: "10px", top: "50%", transform: "translateY(-50%)", color: "#3b82f6" },
    filterControls: { display: "flex", gap: "15px", alignItems: "center", flexWrap: "wrap" },
    filterGroup: { display: "flex", alignItems: "center", gap: "6px", fontSize: "11px", color: isDark ? "#64748b" : "#475569" },
    select: { padding: "5px 8px", background: isDark ? "#141824" : "#ffffff", border: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0", borderRadius: "5px", color: isDark ? "#f1f5f9" : "#1e293b", cursor: "pointer", fontSize: "11px" },
    showHidden: { display: "flex", alignItems: "center", gap: "5px", fontSize: "11px", color: isDark ? "#64748b" : "#475569" },
    locationFilterContainer: { 
      display: "flex", alignItems: "center", gap: "10px", padding: "6px 12px",
      background: isDark ? "#141824" : "#ffffff", border: `1px solid ${isDark ? "#1e2740" : "#e2e8f0"}`,
      borderRadius: "8px", marginBottom: "14px", flexWrap: "wrap"
    },
    locationSelect: { padding: "6px 10px", background: isDark ? "#0d1117" : "#f8fafc", border: `1px solid ${isDark ? "#1e2740" : "#e2e8f0"}`, borderRadius: "5px", color: isDark ? "#f1f5f9" : "#1e293b", cursor: "pointer", fontSize: "11px", minWidth: "160px" },
    locationStat: { fontSize: "10px", color: isDark ? "#94a3b8" : "#64748b", padding: "3px 8px", background: isDark ? "#1e2740" : "#f1f5f9", borderRadius: "16px", display: "inline-flex", alignItems: "center", gap: "4px" },
    tableWrapper: { background: isDark ? "#141824" : "#ffffff", border: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0", borderRadius: "12px", overflow: "hidden", width: "100%" },
    table: { width: "100%", borderCollapse: "collapse", tableLayout: "fixed" },
    th: (width) => ({ 
      padding: "10px 6px", textAlign: "left", fontSize: "10px", fontWeight: 700, 
      color: "#3b82f6", borderBottom: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0", 
      background: isDark ? "#0f1520" : "#f8fafc", width: width || "auto",
      whiteSpace: "nowrap"
    }),
    td: { 
      padding: "8px 6px", borderBottom: isDark ? "1px solid #1a2035" : "1px solid #f1f5f9", 
      fontSize: "11px", color: isDark ? "#e2e8f0" : "#1e293b",
      whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis"
    },
    pagination: { display: "flex", alignItems: "center", justifyContent: "space-between", padding: "10px 16px", borderTop: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0", background: isDark ? "#0f1520" : "#f8fafc", flexWrap: "wrap", gap: "10px" },
    viewMoreBtn: { background: "#3b82f6", color: "white", border: "none", padding: "3px 8px", borderRadius: "4px", cursor: "pointer", fontSize: "9px", fontWeight: 500, whiteSpace: "nowrap" },
    restaurantName: { fontWeight: 600, fontSize: "11px", maxWidth: "130px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", display: "inline-block" },
    ratingWrapper: { 
      display: "flex", 
      alignItems: "center", 
      gap: "3px", 
      fontSize: "10px", 
      whiteSpace: "nowrap",
      color: isDark ? "#fbbf24" : "#d97706"  // Gold color for rating
    },
    idText: { fontFamily: "monospace", fontSize: "9px", color: "#3b82f6" },
    contactText: { fontSize: "10px", whiteSpace: "nowrap", color: isDark ? "#e2e8f0" : "#1e293b" },
    preFilteredBadge: { 
      display: "inline-flex", alignItems: "center", gap: "6px",
      padding: "4px 12px", borderRadius: "16px",
      background: "rgba(59,130,246,0.12)",
      color: "#3b82f6", fontSize: "11px", fontWeight: 500,
      border: "1px solid rgba(59,130,246,0.2)"
    }
  };

  if (showDetailPage) {
    return (
      <RestaurantDetailPage
        restaurant={showDetailPage}
        onBack={() => setShowDetailPage(null)}
        onEdit={(restaurant) => handleEditRestaurantClick(restaurant)}
        onDelete={(restaurant) => handleDeleteFromDetail(restaurant)}
        onViewSchedule={(restaurant) => openScheduleModal(restaurant)}
        onViewMenu={(restaurant) => setShowMenuModal(restaurant)}
        isDark={isDark}
      />
    );
  }

  const handleRowsPerPageChange = (e) => {
    setPerPage(Number(e.target.value));
    setPage(1);
  };

  return (
    <div style={styles.container}>
      <style>{`
        @keyframes slideDown {
          from { opacity: 0; transform: translateY(-10px) scale(0.98); }
          to { opacity: 1; transform: translateY(0) scale(1); }
        }
        @keyframes slideUp { from{transform:translateY(20px);opacity:0} to{transform:translateY(0);opacity:1} }
        @keyframes fadeIn { from{opacity:0} to{opacity:1} }
        @keyframes shimmer {
          0% { transform: translateX(-100%); }
          100% { transform: translateX(100%); }
        }
        .action-btn {
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
          position: relative;
          overflow: hidden;
          display: flex !important;
          align-items: center !important;
          gap: 4px !important;
          padding: 5px 12px !important;
          border-radius: 6px !important;
          border: none !important;
          font-size: 10px !important;
          font-weight: 600 !important;
          cursor: pointer !important;
          white-space: nowrap !important;
        }
        .action-btn:disabled { opacity: 0.5; cursor: not-allowed !important; }
        .action-btn::after {
          content: '';
          position: absolute;
          inset: 0;
          background: radial-gradient(circle at center, rgba(255,255,255,0.15), transparent);
          opacity: 0;
          transition: opacity 0.3s ease;
          pointer-events: none;
        }
        .action-btn:hover::after { opacity: 1; }
        .action-btn:active { transform: scale(0.95) !important; }
        .clear-btn {
          transition: all 0.2s ease;
          display: flex;
          align-items: center;
          gap: 4px;
        }
        .clear-btn:hover { 
          background: ${isDark ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.03)"} !important; 
          color: ${isDark ? "#f1f5f9" : "#0f172a"} !important; 
        }
      `}</style>

      <div style={styles.headerActions}>
        <button style={styles.addBtn} onClick={handleAddRestaurantClick}>
          <PlusIcon /> Add Restaurant
        </button>
        {isPreFiltered && (
          <span style={styles.preFilteredBadge}>
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M12 2L2 7l10 5 10-5-10-5z"/>
              <path d="M2 17l10 5 10-5"/>
              <path d="M2 12l10 5 10-5"/>
            </svg>
            Filtered View: {total} Active Restaurants
          </span>
        )}
      </div>

      <div style={styles.filtersBar}>
        <div style={styles.searchWrapper}>
          <span style={styles.searchIcon}><SearchIcon /></span>
          <input type="text" style={styles.searchInput} placeholder="Search by Name, ID, Contact, Email, Address, Bank, GST, City..." value={search} onChange={(e) => setSearch(e.target.value)} />
        </div>
        <div style={styles.filterControls}>
          <label style={styles.showHidden}>
            <input type="checkbox" /> Show Hidden
          </label>
          <div style={styles.filterGroup}>
            <label>Status:</label>
            <select style={styles.select} value={statusFilter} onChange={(e) => { setStatusFilter(e.target.value); setPage(1); }}>
              <option>All</option><option>Active</option><option>Inactive</option>
            </select>
          </div>
          <div style={styles.filterGroup}>
            <label>Ready:</label>
            <select style={styles.select} value={readyFilter} onChange={(e) => { setReadyFilter(e.target.value); setPage(1); }}>
              <option>All</option><option>Yes</option><option>No</option>
            </select>
          </div>
          <div style={styles.filterGroup}>
            <label>ON/OFF:</label>
            <select style={styles.select} value={onOffFilter} onChange={(e) => { setOnOffFilter(e.target.value); setPage(1); }}>
              <option>All</option><option>ON</option><option>OFF</option>
            </select>
          </div>
        </div>
      </div>

      <div style={styles.locationFilterContainer}>
        <LocationPinIcon style={{ color: "#3b82f6", width: "12px", height: "12px" }} />
        <span style={{ fontSize: "11px", fontWeight: 600, color: isDark ? "#f1f5f9" : "#1e293b" }}>Location:</span>
        <select style={styles.locationSelect} value={locationFilter} onChange={(e) => { setLocationFilter(e.target.value); setPage(1); }}>
          {uniqueLocations.map((location, idx) => (
            <option key={idx} value={location}>
              {location} {location !== "All" && `(${locationStats[location] || 0})`}
            </option>
          ))}
        </select>
        <div style={{ display: "flex", gap: "5px", flexWrap: "wrap", marginLeft: "auto" }}>
          {Object.entries(locationStats).slice(0, 3).map(([location, count]) => (
            <span key={location} style={styles.locationStat}>
              <LocationPinIcon style={{ width: "8px", height: "8px" }} />
              {location}: {count}
            </span>
          ))}
          {Object.keys(locationStats).length > 3 && (
            <span style={styles.locationStat}>+{Object.keys(locationStats).length - 3} more</span>
          )}
        </div>
      </div>

      {/* Selection Bar with Action Buttons */}
      {selected.size > 0 && (
        <div style={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
          background: isDark 
            ? "linear-gradient(135deg, rgba(59,130,246,0.12), rgba(139,92,246,0.08))" 
            : "linear-gradient(135deg, rgba(59,130,246,0.06), rgba(139,92,246,0.04))",
          border: isDark 
            ? "1px solid rgba(59,130,246,0.25)" 
            : "1px solid rgba(59,130,246,0.15)",
          borderRadius: "12px",
          padding: "10px 16px",
          marginBottom: "14px",
          flexWrap: "wrap",
          backdropFilter: "blur(8px)",
          boxShadow: isDark 
            ? "0 4px 20px rgba(59,130,246,0.08)" 
            : "0 4px 20px rgba(59,130,246,0.06)",
          animation: "slideDown 0.3s ease",
          position: "relative",
          overflow: "hidden",
        }}>
          <div style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "linear-gradient(90deg, transparent, rgba(59,130,246,0.05), transparent)",
            animation: "shimmer 3s infinite",
            pointerEvents: "none",
          }} />
          
          <div style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            paddingRight: "14px",
            borderRight: `1px solid ${isDark ? "rgba(59,130,246,0.15)" : "rgba(59,130,246,0.1)"}`,
            flexShrink: 0,
          }}>
            <div style={{
              width: "32px",
              height: "32px",
              borderRadius: "50%",
              background: "linear-gradient(135deg, #3b82f6, #8b5cf6)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "13px",
              fontWeight: 700,
              color: "#fff",
              boxShadow: "0 2px 8px rgba(59,130,246,0.3)",
            }}>
              {selected.size}
            </div>
            <div>
              <span style={{
                fontSize: "13px",
                fontWeight: 600,
                color: isDark ? "#f1f5f9" : "#0f172a",
              }}>
                Restaurant{selected.size > 1 ? "s" : ""} Selected
              </span>
              <span style={{
                fontSize: "10px",
                color: isDark ? "#94a3b8" : "#64748b",
                display: "block",
                marginTop: "-1px",
              }}>
                {selected.size === 1 ? "Click actions below to manage" : `${selected.size} items ready for bulk action`}
              </span>
            </div>
          </div>
          
          <div style={{
            display: "flex",
            gap: "6px",
            flexWrap: "wrap",
            flex: 1,
            alignItems: "center",
          }}>
            <button 
              className="action-btn"
              onClick={() => handleBulkAction('activated')}
              disabled={actionLoading}
              style={{
                background: "rgba(16,185,129,0.12)",
                color: "#059669",
                border: "1px solid rgba(16,185,129,0.2)",
              }}
            >
              <CheckCircleIcon /> Activate
            </button>
            
            <button 
              className="action-btn"
              onClick={() => handleBulkAction('deactivated')}
              disabled={actionLoading}
              style={{
                background: "rgba(239,68,68,0.12)",
                color: "#dc2626",
                border: "1px solid rgba(239,68,68,0.2)",
              }}
            >
              <XCircleIcon /> Deactivate
            </button>
            
            <div style={{ width: "1px", height: "24px", background: isDark ? "#2a3145" : "#e2e8f0" }} />
            
            <button 
              className="action-btn"
              onClick={() => handleBulkAction('set ready')}
              disabled={actionLoading}
              style={{
                background: "rgba(20,184,166,0.12)",
                color: "#0d9488",
                border: "1px solid rgba(20,184,166,0.2)",
              }}
            >
              <ShieldCheckIcon /> Set Ready
            </button>
            
            <button 
              className="action-btn"
              onClick={() => handleBulkAction('unset ready')}
              disabled={actionLoading}
              style={{
                background: "rgba(245,158,11,0.12)",
                color: "#d97706",
                border: "1px solid rgba(245,158,11,0.2)",
              }}
            >
              <ShieldOffIcon /> Unset Ready
            </button>
            
            <div style={{ width: "1px", height: "24px", background: isDark ? "#2a3145" : "#e2e8f0" }} />
            
            <button 
              className="action-btn"
              onClick={() => handleBulkAction('turned ON')}
              disabled={actionLoading}
              style={{
                background: "rgba(34,197,94,0.12)",
                color: "#16a34a",
                border: "1px solid rgba(34,197,94,0.2)",
              }}
            >
              <PowerIcon /> Turn ON
            </button>
            
            <button 
              className="action-btn"
              onClick={() => handleBulkAction('turned OFF')}
              disabled={actionLoading}
              style={{
                background: "rgba(148,163,184,0.12)",
                color: "#6b7280",
                border: "1px solid rgba(148,163,184,0.2)",
              }}
            >
              <PowerIcon /> Turn OFF
            </button>
            
            <div style={{ width: "1px", height: "24px", background: isDark ? "#2a3145" : "#e2e8f0" }} />
            
            <button 
              className="action-btn"
              onClick={() => showToast("Delete menu functionality coming soon", "info")}
              disabled={actionLoading}
              style={{
                background: "rgba(139,92,246,0.12)",
                color: "#7c3aed",
                border: "1px solid rgba(139,92,246,0.2)",
              }}
            >
              <MenuIcon /> Delete Menu
            </button>
            
            <button 
              className="action-btn"
              onClick={() => setShowDeleteModal({ id: Array.from(selected), name: `${selected.size} restaurants` })}
              disabled={actionLoading}
              style={{
                background: "rgba(239,68,68,0.15)",
                color: "#dc2626",
                border: "1px solid rgba(239,68,68,0.25)",
                fontWeight: 700,
              }}
            >
              <TrashIcon /> Delete
            </button>
          </div>
          
          <button 
            onClick={clearSelection} 
            className="clear-btn"
            style={{
              padding: "4px 12px",
              borderRadius: "6px",
              border: isDark ? "1px solid #2a3145" : "1px solid #e2e8f0",
              background: "transparent",
              color: isDark ? "#94a3b8" : "#64748b",
              fontSize: "11px",
              fontWeight: 500,
              cursor: "pointer",
              flexShrink: 0,
            }}
          >
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            Clear
          </button>
        </div>
      )}

      <div style={styles.tableWrapper}>
        <div style={{ overflowX: "auto", WebkitOverflowScrolling: "touch" }}>
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.th(columnWidths.checkbox)}><Checkbox checked={allPageSelected} onChange={toggleAll} /></th>
                <th style={styles.th(columnWidths.sn)}>#</th>
                <th style={styles.th(columnWidths.id)}>ID</th>
                <th style={styles.th(columnWidths.status)}>Status</th>
                <th style={styles.th(columnWidths.ready)}>Ready</th>
                <th style={styles.th(columnWidths.onoff)}>ON/OFF</th>
                <th style={styles.th(columnWidths.open)}>Open</th>
                <th style={styles.th(columnWidths.close)}>Close</th>
                <th style={styles.th(columnWidths.restaurant)}>Restaurant</th>
                <th style={styles.th(columnWidths.rating)}>Rating</th>
                <th style={styles.th(columnWidths.contact)}>Contact</th>
                <th style={styles.th(columnWidths.actions)}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                Array.from({ length: perPage }).map((_, i) => (
                  <tr key={`skeleton-${i}`}>
                    {Array.from({ length: 12 }).map((_, j) => (
                      <td key={`skeleton-cell-${i}-${j}`} style={styles.td}>
                        <div style={{ height: "10px", background: isDark ? "#1e2740" : "#e2e8f0", borderRadius: "3px", width: j === 0 ? "12px" : "70%" }} />
                      </td>
                    ))}
                  </tr>
                ))
              ) : mappedRestaurants.length === 0 ? (
                <tr><td colSpan={12} style={{ padding: "50px", textAlign: "center", color: "#64748b", fontSize: "12px" }}>
                  {isPreFiltered ? "No active restaurants found" : debouncedSearch ? "No results found matching your search" : "No restaurants found"}
                </td></tr>
              ) : (
                mappedRestaurants.map((restro) => (
                  <tr key={restro.id} style={{ background: selected.has(restro.id) ? "rgba(59,130,246,0.07)" : "transparent" }}>
                    <td style={styles.td}><Checkbox checked={selected.has(restro.id)} onChange={() => toggleOne(restro.id)} /></td>
                    <td style={styles.td}>{restro.sn}</td>
                    <td style={styles.td}><span style={styles.idText}>{restro.restroId}</span></td>
                    <td style={styles.td}><StatusBadge status={restro.status} /></td>
                    <td style={styles.td}><ReadyBadge ready={restro.ready} /></td>
                    <td style={styles.td}><OnOffBadge value={restro.onOff} /></td>
                    <td style={styles.td}>{restro.shiftStart || "-"}</td>
                    <td style={styles.td}>{restro.shiftEnd || "-"}</td>
                    <td style={styles.td}><span style={styles.restaurantName} title={restro.organisation_name || restro.name}>{restro.organisation_name || restro.name || "N/A"}</span></td>
                    
                    {/* ✅ RATING CELL - GOLD/YELLOW COLOR */}
                    <td style={styles.td}>
                      <div style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "4px",
                        fontSize: "10px",
                        whiteSpace: "nowrap"
                      }}>
                        <StarIcon style={{ color: "#fbbf24" }} /> 
                        <span style={{ 
                          fontWeight: 600, 
                          color: isDark ? "#fbbf24" : "#d97706"  // Gold color
                        }}>
                          {restro.rating || 0}
                        </span>
                        <span style={{ 
                          fontSize: "9px", 
                          color: isDark ? "#94a3b8" : "#9ca3af" 
                        }}>
                          ({restro.totalRatings || 0})
                        </span>
                      </div>
                    </td>
                    {/* END OF RATING CELL */}
                    
                    <td style={styles.td}><span style={styles.contactText}>{restro.contact || "-"}</span></td>
                    <td style={styles.td}>
                      <button 
                        style={styles.viewMoreBtn} 
                        onClick={() => handleViewRestaurant(restro)}
                      >
                        View
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        <div style={styles.pagination}>
          <div style={{ display: "flex", alignItems: "center", gap: "12px", flexWrap: "wrap" }}>
            <span style={{ fontSize: "10px", color: "#64748b" }}>
              {loading ? "Loading..." : `${Math.min((page-1)*perPage+1, total)}–${Math.min(page*perPage, total)} of ${total}`}
            </span>
            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <span style={{ fontSize: "10px", color: "#64748b" }}>Rows:</span>
              <select 
                value={perPage} 
                onChange={handleRowsPerPageChange}
                style={{
                  padding: "4px 8px",
                  borderRadius: "4px",
                  border: isDark ? "1px solid #1e2740" : "1px solid #e2e8f0",
                  background: isDark ? "#0d1117" : "#ffffff",
                  color: isDark ? "#f1f5f9" : "#1e293b",
                  fontSize: "10px",
                  cursor: "pointer",
                  outline: "none"
                }}
              >
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={30}>30</option>
              </select>
            </div>
          </div>
         <div style={{ display: "flex", gap: "3px", flexWrap: "wrap" }}>
  {/* First Page */}
  <button 
    onClick={goToFirstPage} 
    disabled={page === 1 || loading} 
    style={{ 
      width: "26px", height: "26px", borderRadius: "5px", 
      border: "1px solid #e2e8f0", 
      background: page === 1 ? "#f1f5f9" : "#ffffff", 
      color: page === 1 ? "#94a3b8" : "#475569", 
      cursor: page === 1 ? "not-allowed" : "pointer", 
      fontSize: "9px", fontWeight: 700 
    }}
    title="First Page"
  >
    ««
  </button>
  
  {/* Previous */}
  <button 
    onClick={() => setPage(p => Math.max(1, p-1))} 
    disabled={page === 1 || loading} 
    style={{ 
      width: "26px", height: "26px", borderRadius: "5px", 
      border: "1px solid #e2e8f0", 
      background: page === 1 ? "#f1f5f9" : "#ffffff", 
      color: page === 1 ? "#94a3b8" : "#475569", 
      cursor: page === 1 ? "not-allowed" : "pointer", 
      fontSize: "10px" 
    }}
  >
    <ChevronLeftIcon />
  </button>
  
  {/* Page Numbers */}
  {Array.from({ length: Math.min(5, totalPages) }, (_, i) => { 
    let p; 
    if (totalPages <= 5) p = i + 1;
    else if (page <= 3) p = i + 1;
    else if (page >= totalPages - 2) p = totalPages - 4 + i;
    else p = page - 2 + i;
    return p <= totalPages && (
      <button 
        key={p} 
        onClick={() => setPage(p)} 
        style={{ 
          width: "26px", height: "26px", borderRadius: "5px", 
          fontSize: "10px", 
          border: page === p ? "2px solid #3b82f6" : "1px solid #e2e8f0", 
          background: page === p ? "#eff6ff" : "#ffffff", 
          color: page === p ? "#1d4ed8" : "#475569", 
          cursor: "pointer",
          fontWeight: page === p ? 700 : 400
        }}
      >
        {p}
      </button>
    ); 
  })}
  
  {/* Next */}
  <button 
    onClick={() => setPage(p => Math.min(totalPages, p+1))} 
    disabled={page === totalPages || loading} 
    style={{ 
      width: "26px", height: "26px", borderRadius: "5px", 
      border: "1px solid #e2e8f0", 
      background: page === totalPages ? "#f1f5f9" : "#ffffff", 
      color: page === totalPages ? "#94a3b8" : "#475569", 
      cursor: page === totalPages ? "not-allowed" : "pointer", 
      fontSize: "10px" 
    }}
  >
    <ChevronRightIcon />
  </button>
  
  {/* Last Page */}
  <button 
    onClick={goToLastPage} 
    disabled={page === totalPages || loading || totalPages === 0} 
    style={{ 
      width: "26px", height: "26px", borderRadius: "5px", 
      border: "1px solid #e2e8f0", 
      background: (page === totalPages || totalPages === 0) ? "#f1f5f9" : "#ffffff", 
      color: (page === totalPages || totalPages === 0) ? "#94a3b8" : "#475569", 
      cursor: (page === totalPages || totalPages === 0) ? "not-allowed" : "pointer", 
      fontSize: "9px", fontWeight: 700 
    }}
    title="Last Page"
  >
    »»
  </button>
</div>
        </div>
      </div>

      <DeleteConfirmModal 
        isOpen={!!showDeleteModal} 
        restaurantName={showDeleteModal?.name || showDeleteModal?.organisation_name || ""} 
        onConfirm={() => {
          if (showDeleteModal?.id === Array.from(selected) && selected.size > 0) handleDeleteSelected();
          else if (showDeleteModal?.id) { showToast("Restaurant deleted"); setShowDeleteModal(null); fetchRestaurants(); if (showDetailPage && showDetailPage.id === showDeleteModal.id) setShowDetailPage(null); }
          else if (showDeleteModal?.id && Array.isArray(showDeleteModal.id)) handleDeleteSelected();
        }} 
        onCancel={() => setShowDeleteModal(null)} 
        isDark={isDark} 
      />
      
      <ScheduleModal 
        isOpen={showScheduleModal} 
        restaurant={scheduleRestaurant} 
        scheduleItems={scheduleItems} 
        onUpdate={updateScheduleItem} 
        onDelete={deleteScheduleItem} 
        onAdd={addScheduleItem} 
        onClose={() => { setShowScheduleModal(false); setScheduleRestaurant(null); }} 
        onSave={saveSchedule} 
        isDark={isDark} 
      />
      
      {showMenuModal && <RestaurantMenuModal restaurant={showMenuModal} onClose={() => setShowMenuModal(null)} isDark={isDark} />}
      {toast && <Toast message={toast.message} type={toast.type} onClose={() => setToast(null)} />}
    </div>
  );
};

export default RestaurantTable;